import { render } from "./Other.vue?vue&type=template&id=0d95d036&scoped=true&ts=true"
import script from "./Other.vue?vue&type=script&lang=ts"
export * from "./Other.vue?vue&type=script&lang=ts"

import "./Other.vue?vue&type=style&index=0&id=0d95d036&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d95d036"]])

export default __exports__